const ThemeCardSmall = ({ id, title, onSelect, isSelected }) => {
    return (
        <div
            className={`p-2 border rounded-lg cursor-pointer ${isSelected ? "bg-blue-200" : "hover:bg-gray-100"}`}
            onClick={() => onSelect(id)}
        >
            <h4 className="text-sm font-medium">{title}</h4>
        </div>
    );
};

export default ThemeCardSmall;
